export const formatDateString = (date: string, options: Intl.DateTimeFormatOptions) => {
  return new Intl.DateTimeFormat('pt-BR', options).format(new Date(date))
}
